<template>
  <div id="roomContent">
    <div class="page-content">
      <div v-if="!user.name">
        <text-link :route="'/'" :labelLink="'Scegli un nickname per giocare'" />
      </div>
      <div v-else-if="user.name && !table.name">
        <text-link :route="'/tables'" :labelLink="'Scegli un tavolo per giocare'" />
      </div>
      <div v-else-if="user.name && table.name">
        <div class="wrap">
          <div>
            <a v-on:click="startGame()">
              <div id="grid-room">
                <WaitingPlayer id="player4" :player="table.users[3]" />
                <div>
                  <WaitingPlayer id="player1" :player="table.users[0]" />
                  <WaitingPlayer id="player3" :player="table.users[2]" />
                  <div id="table" :class="{hoverable: table.users[4] && user.id}">
                    <h1 id="tableName">{{ table.name }}</h1>
                    <h1
                      id="start"
                      v-if="table && table.users && table.users.length == 5 && table.queue.length == 0"
                      class="pulsate"
                    >INIZIA!</h1>
                  </div>
                  <WaitingPlayer id="player5" :player="table.users[4]" />
                </div>
                <WaitingPlayer id="player2" :player="table.users[1]" />
              </div>
            </a>
          </div>
          <div v-if="table.queue.length" id="waitingList">
            <div><h3>In attesa di giocare:</h3></div>
            <WaitingPlayer v-for="(user, index) in table.queue" :id="'player'+(index+6)" :key="'player'+(index+6)" :player="user"/>
          </div>
        </div>
        
        <div id="button-table">
          <div id="add-bot" v-if="!table.users[4]">
            <game-button @clicked="addBot()" :disabled="clicked">{{ $t('waiting.addbot') }}</game-button>
          </div>
          <div id="leave-game">
            <game-button @clicked="leaveTable()">{{ $t('waiting.leave') }}</game-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TextLink from "./TextLink";
import router from "@/router";
import WaitingPlayer from "@/components/WaitingPlayer";
import GameButton from "@/components/Button";

export default {
  name: "WaitingRoom",
  components: {
    TextLink,
    WaitingPlayer,
    GameButton
  },
  data() {
    return {
      clicked: false
    };
  },
  mounted() {
    window.Echo.channel("games").listen("TableSeatEvent", e => {
      if (e.user.id == this.$store.getters["user/userId"]) {
        return;
      }
      this.$store.commit("tables/addUserToTableById", e);
    });
    window.Echo.channel("games").listen("TableStandupEvent", e => {
      if (e.user.id != this.user.id) {
        this.$store.commit("tables/deleteUserFromTablesById", e);
      }
    });
    window.Echo.channel("games").listen("DeletedTableEvent", e => {
      this.$store.commit("tables/removeTable", e);
    });
  },
  beforeDestroy() {
    window.Echo.channel("games")
      .stopListening("TableSeatEvent")
      .stopListening("TableStandupEvent")
      .stopListening("DeletedTableEvent");
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      table: "tables/tableActive"
    })
  },
  methods: {
    startGame() {
      if (
        (this.table && this.table.users && this.table.users.length != 5) ||
        this.clicked
      ) {
        return;
      }
      this.clicked = true;
      const payload = {
        tableId: this.table.id
      };
      this.$store.dispatch("game/startGame", payload).then(() => {
        this.clicked = false;
      });
    },
    leaveTable() {
      this.clicked = true;
      window.Echo.channel("table-" + this.table.id).stopListening(
        "GameStartEvent"
      );
      const payload = {
        userId: this.user.id
      };
      if (this.table.queue.findIndex(userQueue => userQueue.id == this.user.id) != -1) {
        this.$store.dispatch("tables/removeMeFromQueue", payload);
      }
      this.$store.dispatch("tables/leaveTable", payload).then(result => {
        if (!result) {
          const userData = {
            userId: this.user.id
          };
          this.$store.dispatch("user/deleteUser", userData).then(() => {
            this.$store.commit("call/resetCall");
            this.$store.commit("game/exit");
            this.$store.commit("chat/resetChat");
            this.$store.commit("results/resetResults");
            router.push("/");
          });
        } else {
          window.Echo.channel("games")
                     .stopListening("TableSeatEvent")
                     .stopListening("TableStandupEvent");
          router.push("/tables");
        }
      });
    },
    addBot() {
      this.clicked = true;
      this.$store.dispatch("tables/addBot", this.table.id).then(() => {
        this.clicked = false;
      });
    }
  }
};
</script>
<style scoped>
#players {
  padding-top: 5em;
  display: flex;
  align-items: center;
  justify-content: center;
}
#grid-room {
  display: flex;
  justify-content: center;
  align-items: center;
}
#player1 {
  transform: translateX(-23%) translateY(+54%) rotate(-38deg);
}
#player2 {
  transform: translateX(-44%) translateY(74%) rotate(109deg);
}
#player3 {
  transform: translateX(46%) translateY(26%) rotate(+38deg);
}
#player4 {
  transform: translateX(+44%) translateY(73%) rotate(251deg);
}
#player5 {
  margin-top: 2em;
  transform: translateX(14%) translateY(-23%);
}
.pulsate {
  -webkit-animation: pulsate 1s ease-out;
  -webkit-animation-iteration-count: infinite;
  opacity: 0.5;
  font-size: 24px;
}
@-webkit-keyframes pulsate {
  0% {
    opacity: 0.5;
    font-size: 24px;
  }
  50% {
    opacity: 1;
    font-size: 40px;
  }
  100% {
    opacity: 0.5;
    font-size: 24px;
  }
}
.page-content {
  padding-top: 5em;
}
#leave-game {
  display: flex;
  justify-content: center;
}
.form-button {
  margin: 0.5em;
  padding: 0.5em;
}
#table {
  width: 216px;
  border-width: 200px 72px 0;
  margin-top: 4em;
  position: relative;
  box-sizing: content-box;
  border-style: solid;
  border-color: rgb(255, 153, 0) transparent;
}
#table:before {
  top: -340px;
  left: -72px;
  border-width: 0 180px 140px;
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  border-style: solid;
  border-color: transparent transparent rgb(255, 153, 0);
}
#tableName {
  font-weight: 800;
  position: absolute;
  margin-top: -7em;
  color: black;
  width: inherit;
}
#start {
  font-weight: 800;
  position: absolute;
  margin-top: -3em;
  color: black;
  width: inherit;
}
.hoverable:hover {
  border-color: rgb(255, 204, 0) transparent !important;
  cursor: pointer;
}
.hoverable:hover:before {
  border-color: transparent transparent rgb(255, 204, 0) !important;
  cursor: pointer;
}
#playButton {
  position: absolute;
  margin-top: -6em;
  width: inherit;
}
.player-box {
  border-radius: 5px;
  background-color: black;
  color: antiquewhite;
}
.empty {
  background-color: antiquewhite;
  color: black;
}
#button-table {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 4em;
  flex-wrap: wrap;
}
#waitingList {
  margin-top: 3em; 
}
.player-box {
  margin: 0em; 
}
@media all and (max-width: 550px), (max-height: 400px) {

  .page-content {
    padding-top: 1em;
  }
  #leave-game {
    justify-content: center;
  }
  #table {
    width: 108px;
    border-width: 100px 36px 0;
  }
  #table:before {
    top: -170px;
    left: -36px;
    border-width: 0 90px 70px;
  }
  #tableName {
    margin-top: -6em;
    font-size: 18px;
  }
  #start {
    margin-top: -3em;
  }
  #player1 {
    transform: translateX(-26%) translateY(+190%) rotate(-38deg);
  }
  #player2 {
    transform: translateX(-47%) translateY(89%) rotate(109deg);
  }
  #player3 {
    transform: translateX(42%) translateY(115%) rotate(+38deg);
  }
  #player4 {
    transform: translateX(+45%) translateY(85%) rotate(251deg);
  }
  #player5 {
    margin-top: 1em;
    transform: translateX(10%) translateY(-31%);
  }
  .pulsate {
    -webkit-animation: pulsate 1s ease-out;
    -webkit-animation-iteration-count: infinite;
    opacity: 0.5;
    font-size: 16px;
  }
  @-webkit-keyframes pulsate {
    0% {
      opacity: 0.5;
      font-size: 16px;
    }
    50% {
      opacity: 1;
      font-size: 24px;
    }
    100% {
      opacity: 0.5;
      font-size: 16px;
    }
  }
}
</style>